import React from 'react';
import { TileLayer } from 'react-leaflet';
import './BasemapTiles.css';

// Share the existing key-free basemap. Filter only this layer, never markers,
// weather overlays, popups or attribution. Browser HTTP caching stays enabled.
export default function BasemapTiles({ dark = false }) {
  return <TileLayer key={dark ? 'osm-dark' : 'osm-light'}
    url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    className={dark ? 'cad-basemap-dark' : 'cad-basemap-light'} maxZoom={19} />;
}
